import React from "react";
import "./servicemain.scss";
import Services1 from "../../../assets/images/Services (1).svg";
import Services2 from "../../../assets/images/Services (2).svg";
import Services3 from "../../../assets/images/Services (3).svg";
import Services4 from "../../../assets/images/Services (4).svg";
import Services5 from "../../../assets/images/Service (5).svg";
import { NavLink } from "react-router-dom";
import { Fade } from "react-reveal";
export default function MainGrid() {
  const Service_card = [
    {
      image: Services1,
      heading: "Mobile App Development",
      description:
        "We create custom mobile apps that give your business a competitive advantage in the market, integrating innovative features that improve engagement without compromising on their functionality.",
      read_more: "Read More",
    },
    {
      image: Services2,
      heading: "Fronted Development",
      description:
        "Elevate your digital presence with our frontend development expertise. From captivating designs to intuitive user interfaces, we craft immersive web and mobile experiences. Let us transform your vision into stunning realities that engage and inspire your audience.",
      read_more: "Read More",
    },
    {
      image: Services3,
      heading: "Backend Development",
      description:
        "Unlock the engine behind seamless user experiences with our expert backend development services. From robust APIs to scalable architectures, we ensure your digital infrastructure is primed for efficiency, reliability, and future growth. Trust us to power your digital ambitions.",
      read_more: "Read More",
    },
    {
      image: Services4,
      heading: "Blockchain",
      description:
        "Unlock the potential of blockchain technology with Vedhas AI Technologies'. Our managed blockchain service, hosted in the cloud, provides a seamless platform for developing blockchain digital services. With Vedhas AI as your trusted partner, you can harness the benefits of blockchain infrastructure or building complex systems from scratch.",
      read_more: "Read More",
    },
    {
      image: Services5,
      heading: "UI/UX Design",
      description:
        "We create high-functioning software products that elevate the experience of your end-users, bringing together all visual and functional elements of your software to ensure that they reflect the quality of the services you have to offer.",
      read_more: "Read More",
    },
    {
      image: Services3,
      heading: "AI / ML App Services",
      description:
        "Unlock the potential of AI/ML with our cutting-edge app services. From predictive analytics to personalized recommendations, we integrate advanced algorithms to empower your applications. Experience enhanced efficiency, accuracy, and innovation as we revolutionize your digital solutions with AI/ML capabilities.",
      read_more: "Read More",
    },
  ];
  return (
    <section className="service_page_card">
      <div className="container">
        <div className="service-main-grid">
          {Service_card &&
            Service_card?.map((el, i) => {
              return (
                <Fade bottom duration={800} delay={700} key={i}>
                  <div className="service-sub-card" title={el?.heading}>
                    <div className="description">
                      <img src={el?.image} alt="Icon1" />
                      <h2>{el?.heading}</h2>
                      <p>{el?.description}</p>
                    </div>
                    <NavLink
                      to="/mobileapp"
                      style={({ isActive }) => ({
                        color: isActive ? "#583FBB" : "#583FBB",
                        textDecoration: "none",
                      })}
                    >
                      <h3 title={el?.read_more}>
                        {el?.read_more}{" "}
                        <svg
                          width="21"
                          height="8"
                          viewBox="0 0 21 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4.5H20V3.5H0V4.5Z"
                            fill="url(#paint0_linear_11_161)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_11_161"
                              x1="2"
                              y1="3.49996"
                              x2="73"
                              y2="3.99997"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#8F55CA" />
                              <stop offset="1" stop-opacity="0" />
                              <stop offset="1" stop-color="#7349C2" />
                              <stop offset="1" stop-color="#7349C2" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </h3>
                    </NavLink>
                  </div>
                </Fade>
              );
            })}
        </div>
      </div>
    </section>
  );
}
